import { Facebook, Instagram, Twitter, Mail, Phone, MapPin, Youtube } from 'lucide-react';
import BauhausPattern from './BauhausPattern';

const Footer = () => {
    return (
        <footer className="footer">
            <BauhausPattern />
            <div className="footer-content">
                <div className="footer-brand">
                    <a href="/"><img src="/footer logo.png" alt="Hollywood Royale Garden" className="footer-logo" /></a>
                    <p>An assisted living community where comfort meets care, surrounded by nature and dedicated staff.</p>
                </div>

                <div className="footer-column">
                    <h4>Quick Links</h4>
                    <ul className="footer-links">
                        <li><a href="#property">Our Community</a></li>
                        <li><a href="#amenities">Care Services</a></li>
                        <li><a href="#gallery">Gallery</a></li>
                        <li><a href="#rooms">Rooms & Suites</a></li>
                        <li><a href="/blogs">Blogs</a></li>
                    </ul>
                </div>

                <div className="footer-column">
                    <h4>Contact</h4>
                    <ul className="footer-links">
                        <li><a href="tel:+13234662411"><Phone size={16} /> +1 323-466-2411</a></li>
                        <li><a href="mailto:info@hrgalla.com"><Mail size={16} /> info@hrgalla.com</a></li>
                    </ul>
                    <p style={{ fontSize: '0.875rem', marginTop: '0.75rem', color: '#ffffff' }}>RCFE License # 197610432</p>
                </div>

                <div className="footer-column">
                    <h4>Follow Us</h4>
                    <div className="footer-social">
                        <a href="https://www.instagram.com/hollywood.royale/" className="social-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><Instagram size={18} /></a>
                        <a href="https://www.facebook.com/hollywoodroyalela" className="social-icon" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><Facebook size={18} /></a>
                        <a href="https://x.com/hollywoodroyal_" className="social-icon" aria-label="X" target="_blank" rel="noopener noreferrer"><Twitter size={18} /></a>
                        <a href="https://www.tiktok.com/@hollywood_royale" className="social-icon" aria-label="TikTok" target="_blank" rel="noopener noreferrer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" /></svg>
                        </a>
                        <a href="https://www.youtube.com/@Hollywood.Royale" className="social-icon" aria-label="YouTube" target="_blank" rel="noopener noreferrer"><Youtube size={18} /></a>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Hollywood Royale Garden. All rights reserved.</p>
                {/* <div className="footer-legal">
                    <a href="#">Privacy</a>
                    <a href="#">Terms</a>
                    <a href="#">Accessibility</a>
                </div> */}
                <img src="/equalhosungopertuni.png" alt="Equal Housing Opportunity" className="equal-housing-logo" style={{ height: '40px', marginLeft: 'auto' }} />
            </div>
        </footer>
    );
};

export default Footer;
